<template>
  <div class="todo-item" :class="{'checked': isChecked}">
    <div class="todo-checkbox" @click="toggle">
      <i class="material-icons">{{ icon }}</i>
    </div>
    <div class="todo-label" @click="toggle">{{ label }}</div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: "Option",
  props: ["id", "checked", "label", "listName"],
  data: function() {
    return {
      isChecked: this.checked
    };
  },
  components: {},
  computed: {
    icon() {
      return this.isChecked ? "check_box" : "check_box_outline_blank";
    }
  },
  methods: {
    toggle() {
      this.isChecked = !this.isChecked;
      this.$emit("toggle-option", {
        id: this.id,
        listName: this.listName,
        checked: this.isChecked
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.todo-item {
  float: left;
  width: 260px;
  height: 30px;
  margin: 16px 0;
  font-size: 13pt;
  line-height: 1.2em;
}
.todo-checkbox {
  float: left;
  width: 34px;
  padding: 4px;
  padding-top: 1px;
  font-size: 24pt;
  color: $color-blue;
  transition: all 0.2s ease-in-out;
}
.todo-label {
  float: left;
  width: 190px;
  padding-top: 2px;
  font-size: 13pt;
  line-height: 1.3em;
}

.todo-item:hover {
  .todo-checkbox {
    color: darken($color-blue, 12%);
    cursor: pointer;
    transform: scale(1.1);
  }
  .todo-label {
    color: #666;
    cursor: pointer;
  }
}

.checked {
  .todo-checkbox {
  }
  .todo-label {
    color: $color-blue;
  }
  .todo-action {
    opacity: 0.6;
  }
}
</style>

